import React, { Component } from 'react';
import { Query } from 'react-apollo';
import {
  isEmpty,
  ifElse,
  path,
  curry,
  prop,
} from 'ramda';
import { components as commonComponents } from '@555platform/portal-components/lib/client';
import { RolesContainer, GET_ROLE } from './RolesContainer';
import RoleView from './RoleView';


const dataOr = (defaultValue, dataPath, data) => ifElse(
  isEmpty,
  () => defaultValue,
  () => path(dataPath, data),
)(data);

class EditRole extends Component {
  state = {
    open: true,
  };

  onPermissionChange = curry((handlers, roleIdentifier, resource, action, isEnabled) => {
    const { allowFn, removeFn } = handlers;
    return isEnabled
      ? allowFn({ variables: { action, resource, roleIdentifier } })
      : removeFn({ variables: { action, resource, roleIdentifier } });
  })

  handleClose = () => {
    this.setState({ open: false });
  };

  renderError = () => (
    <commonComponents.ModalErrorDialog
      isOpen={prop('open', this.state)}
      onClose={this.handleClose}
      title="Edit Role"
      message="Oops, we could not access role data!  Please try again later..."
    />
  );

  onRoleIdentifierChange = () => { }

  render() {
    const { match } = this.props;
    const roleID = match.params.id;
    const teamID = match.params.type;

    return (
      <Query
        query={GET_ROLE}
        notifyOnNetworkStatusChange
        variables={{ name: roleID, team: teamID }}
        context={{ useLocalError: true }}
      >
        {({ data, loading, error }) => {
          if (error) return this.renderError();

          return (
            <RolesContainer roleID={roleID} teamID={teamID}>
              {({ allow, removePermission }) => (
                <RoleView
                  title="Edit Role"
                  role={dataOr({ roleIdentifier: { displayName: '', name: '', team: '' } }, ['templatedRole', 'role'], data)}
                  template={dataOr([], ['templatedRole', 'template'], data)}
                  isLoading={loading}
                  readOnly={allow.result.loading || removePermission.result.loading}
                  onPermissionChange={this.onPermissionChange({
                    allowFn: allow.mutation,
                    removeFn: removePermission.mutation,
                  })}
                  onRoleIdentifierChange={this.onRoleIdentifierChange}
                  {...this.props}
                />
              )}
            </RolesContainer>
          );
        }}
      </Query>
    );
  }
}

export default EditRole;
